<div class="flex flex-column">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar class="w-full" title="Devises" (create)="createDevise()"></toolbar>
  </div>
  <div class="alm-card p-0 mb-4 border-round-2xl shadow-1 transition-all transition-duration-300 hover:shadow-3 bg-white">
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <dynamic-table [headers]="columns" [data]="devises" [pageParams]="pageable"
                    [actions]="actions" (paginate)="onPageChange($event)">
        <p-progressSpinner [hidden]="!displaySpinner" strokeWidth="2" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px', stoke: '#004F78' }" />
      </dynamic-table>
    </div>
  </div>
</div>
